
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>{`Scénario B: Avec une app de «Proximity Tracing»`}</h4>
    <p>{`La Confédération a recommandé l'installation d'une application développée par
l'EPFL et l'EPFZ. Grâce à la technologie Bluetooth du smartphone, `}<strong parentName="p">{`les contacts
de plus de quinze minutes et à moins de 1,5 mètre de distance sont enregistrés
de manière anonyme`}</strong>{`. Même le fait de s'asseoir à côté d'une personne que l'on
ne connaît pas dans les transports publics peut être enregistré.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;